<template>
  <div class="bg-white" >
     <div v-if="showPage">
      <div id="header">
        <div class="container-fluid fill-height">
          <v-layout class="fill-height">
            <div
              class="d-flex justify-space-between align-center fill-height"
              style="width: 230px;"
            >
                <img
                  class="logo"
                  src="@/assets/ez-cms-horizontal.png"
                  height="47px"
                  alt
                />
            </div>
            <div
              class="d-flex justify-content-end w-100"
            >
              <v-icon @click="drawerApplication = !drawerApplication">
                apps
              </v-icon>
            </div>
          </v-layout>
        </div>
      </div>
        <div class="d-no-hotel" >
          <div class="text-center">
            <img class="one-inventory" src="@/assets/no-hotel.jpg" alt :style="mobiTablet ? 'width: 165px' : 'width: 270px'" />
            <div class="text-center mt-3">
              {{$t('YOU_DONT_HAVE_ANY_HOTELS_YET')}} <br>
              {{$t('CANNOT_GET_INFO_FROM_OTA_2')}}
            </div>
          </div>
        </div>
        <v-navigation-drawer
          v-model="drawerApplication"
          absolute
          temporary
          right
          :class="mobiTablet ? '' : 'd-application'"
        >
        <div class="d-app">
          <div class="d-app-content">
            <div class="d-search-application">
              <v-text-field class="w-100" v-model="keySearchApp" solo dense :label="$t('ENTER_THE_NAME_OF_THE_APP_WANT_TO_SEARCH_FOR')" prepend-inner-icon="search"></v-text-field>
            </div>
            <v-expansion-panels accordion multiple v-model="panel">
              <v-expansion-panel
                v-for="(item,i) in arrAppView"
                :key="i"
              >
                <v-expansion-panel-header>{{$i18n.locale === 'en' ? item.nameEn : item.name}}</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <b-row>
                    <b-col :cols="mobiTablet ? 6 : 3" v-for="(app, index) in item.appLinks" class="text-center d-app-item" @click="openApp(app)">
                      <div class="d-img-app">
                        <img :src="app.icon">
                      </div>
                      <div >
                        {{app.name}}
                        <p class="fs-10 text-secondary">{{$i18n.locale === 'en' ? app.descriptionEn : app.description}}</p>
                      </div>
                    </b-col>
                  </b-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </div>
      </v-navigation-drawer>
     </div>
  </div>
</template>
<style lang="scss" scoped>
.d-or{
  position: relative;
}
.txt-or{
  position: absolute;
    top: -9px;
    background: #144396;
    width: 30px;
    text-align: center;
    left: 47%;
}
</style>
<script>
import Input from "@/components/Utils/Input.vue";
import { authenticationService } from "@/_services/";
import { _validateEmail } from "@/_helpers/function.js";
import VueRecaptcha from 'vue-recaptcha';
const MODAL_WIDTH = 500;
const MODAL_HEIGHT = 376;
export default {
  components: {
    "input-text": Input,
    VueRecaptcha
  },
  data() {
    return {
      modalWidth: MODAL_WIDTH,
      modalHeight: MODAL_HEIGHT,
      notAccess: null,
      formHeight: 0,
      scale: 1,
      passwordInput: {
        type: "password",
        isShowed: false
      },
      user: {
        username: "",
        password: ""
      },
      resetPass: {
        username: ""
      },
      loginFail: false,
      resetPassFail: false,
      isExpired: false,
      isClearExpiredMsg: 0,
      forgotPassUrl: location.origin + "/forgot-password",
      registerUrl: location.origin + "/register",
      agentLoginUrl: `https://ta.oneinventory.com?lang=${localStorage.getItem("systemLanguage")}`,
      tip: null,
			emailforgot: null,
			emailnotfount: false,
			loginForm: {
				recaptchaVerified: false,
				pleaseTickRecaptchaMessage: '',
			},
      dialogEzID: false,
      urlEzId: null,
      showPage: false,
      keySearchApp: null,
      drawerApplication: false,
      apps: [],
      panel: [0, 1],
      arrAppView: [],
      lang: this.$i18n.locale
    };
  },
  created() {
    if (this.domain.includes('ezcrs') || this.domain.includes('ezcms') || (this.dataMain && this.dataMain.isLoginAdmin === false)) {
      this.getApplication();
      this.unit();
    }
  
  },
  mounted() {
  },
  watch: {
    user: {
      handler(val) {
        this.notAccess = false;
        this.loginFail = false;
        this.resetPassFail = false;
      },
      deep: true
    },
    passwordInput: {
      handler(val) {
        this.passwordInput.type = val.isShowed ? "text" : "password";
      },
      deep: true
    },
    resetPassFail(value) {
      let form = document.getElementById("resetPassword");
      this.formHeight = form.offsetHeight;
    },
     keySearchApp(val) {
      this.arrAppView = this.filterData(this.apps, val);
    },
  },
  computed: {
    isReady() {
      return this.user.username && this.user.password;
    },
  },
  methods: {
    openApp(app) {
      if (app.url) {
        window.open(app.url ? app.url : '#');
      }
    },
    filterData(arr, key) {
      const array = JSON.parse(JSON.stringify(arr));
      if (key) {
        for (let index = 0; index < array.length; index++) {
          array[index].appLinks = array[index].appLinks.filter(app => app.name.toLowerCase().includes(key.toLowerCase()))
        }
        return array;
      }
      return arr
    },
    getApplication() {
       authenticationService
        .getApp()
        .then(res => {
          this.apps = res.data;
          this.arrAppView = res.data;
          // this.filterData(this.apps, 'Cms')
        })
    },
    async unit() {
      await this.$oidc.signinRedirectCallback().then((resEzId) => {
        this.showPage = false;
          authenticationService.loginEzId(resEzId.access_token)
          .then(res => {
            if (res.responseCode != 0) {
              if (res.data === 'USER_NOT_EXIST') {
                this.showPage = true;
                return
              }
              this.$oidc.signoutRedirect();
              alert(this.$t("_LOGIN.INVALID_ACCOUNT_INFO_MESSAGE"));
              return false;
            }
            if (!res.data.user.roles.length) {
              this.notAccess = true;
            }
            this.$session.set('notify_expired', true); 
            localStorage.setItem("jwt", res.data.token);
            this.getAllCurrency();
            this.$router.replace("chain-dashboard");
          });
          return;
      }).catch(e => {
          console.log("signinRedirectCallback", e);
          if (this.domain.includes('ezcrs') || this.domain.includes('ezcms') || (this.dataMain && this.dataMain.isLoginAdmin === false)) {
            this.loginEzId();
          }
      });
    },
    getAllCurrency(e) {
      authenticationService
        .getAllCurrency(e)
        .then(res => {
          if (res.responseCode == 0) {
            localStorage.setItem("currencys", JSON.stringify(res.data));
          }
        });
    },
    agreeEzId() {
      this.dialogEzID = false;
      window.location = this.urlEzId;
    },
    loginEzId() {
      this.$oidc.signinRedirect();
    },
    continuteLogin() {
      this.dialogEzID = false;
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.get("requestCode")) {
        this.$router.push({ name: "requestBookingDetail", params: { code: urlParams.get("requestCode") } });
      } else {
        this.$router.replace("chain-dashboard");
      }
    },
    loginToken(e) {
      if (this.$route.name != "login") {
        return false;
      }
       let loader = this.$loading.show({
        loader: "dots"
      });
      authenticationService
        .loginToken(e)
        .then(res => {
          if (res.responseCode != 0) {
            loader.hide();
            return false;
          }
          if (!res.data.user.roles.length) {
            this.notAccess = true;
          }
          // localStorage.setItem("userInfo", JSON.stringify(res.data));
          localStorage.setItem("jwt", res.data.token);
          loader.hide();
          this.$router.push(
          { 
            name: "roomSales",
          });
        });
    },
    login(e) {
      if (this.$route.name != "login") {
        return false;
      }
      if (!this.isReady) return false;
      let loader = this.$loading.show({
        loader: "dots"
      });
      authenticationService
        .login(this.user.username, this.user.password)
        .then(res => {
          if (res.responseCode != 0) {
            loader.hide();
            this.loginFail = true;
            return false;
          }
          
          if (!res.data.user.roles.length) {
            this.notAccess = true;
          }
          // localStorage.setItem("userInfo", JSON.stringify(res.data));
          localStorage.setItem("jwt", res.data.token);
          if (res.data.hotel) {
            this.optionUTC.forEach(item => {
            item.children.forEach(child => {
              if (child.id === res.data.hotel.timeZoneStr) {
                localStorage.setItem("timeZoneStr", res.data.hotel.timeZoneStr);
                localStorage.setItem("GMT", child.label);
                return;
              }
            })
          })
          }
          if (res.data.urlEzId) {
            loader.hide();
            this.dialogEzID = true;
            this.urlEzId = res.data.urlEzId;
            return;
          }
          loader.hide();
          const urlParams = new URLSearchParams(window.location.search);
           if (urlParams.get("requestCode")) {
            this.$router.push({ name: "requestBookingDetail", params: { code: urlParams.get("requestCode") } });
          } else {
            this.$router.replace("generalInfo");
          }
        });
    },
    toggleShowPassword() {
      this.passwordInput.isShowed = !this.passwordInput.isShowed;
    },
    redirectToRegister() {
      this.$router.replace("register");
    },
    show () {
      this.$modal.show('formatPass');
      this.emailnotfount = false;
			this.emailforgot = null;
      this.loginForm.recaptchaVerified = false;
      this.resetPassFail = false;
    },
    close () {
      this.$modal.hide('formatPass');
    },
    closeNotice (){
      this.$modal.hide('forgotpassSuccess');
    },
		markRecaptchaAsVerified(response) {
			this.loginForm.pleaseTickRecaptchaMessage = '';
			this.loginForm.recaptchaVerified = true;
    },		
    checkIfRecaptchaVerified() {
			// if (!this.loginForm.recaptchaVerified) {
			// 	this.loginForm.pleaseTickRecaptchaMessage = 'Vui lòng đánh dấu vào hộp xác minh';
			// 	return true;
      // }
      this.resetPass.username = this.emailforgot;
			authenticationService
        .forgotPassword(this.resetPass.username)
        .then(res => {
          if (res.responseCode == 0) {
            this.$modal.hide('formatPass');
            this.$modal.show('forgotpassSuccess');
          } else {
						this.emailnotfount = true;
					}
          // loader.hide();
        });
    },
  }
};
</script>